module.exports = __webpack_public_path__ + "static/media/1001008HG.94d873f9.jpg";